function computeTopOffset(node) {
  if (!node) {
    return 0
  }

  let rootNode = node
  let curtop = 0
  let curtopscroll = 0

  if (rootNode.offsetParent) {
    do {
      curtop += rootNode.offsetTop
      curtopscroll += rootNode.offsetParent ? rootNode.offsetParent.scrollTop : 0
      // eslint-disable-next-line no-cond-assign
    } while ((rootNode = rootNode.offsetParent))

    return curtop - curtopscroll
  }
}

export default computeTopOffset
